import FolderNameModal from '@/components/MantineFileManager/FolderNameModal';
import { useUpdateFolderMutation } from '@/features/api/endpoints/folderEndpoints';
import type { DirectusFolders } from '@/models/types';
import { ActionIcon, Tooltip } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconPencil } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

type RenameFolderBtnProps = {
  folder: DirectusFolders;
};

const RenameFolderBtn = ({ folder }: RenameFolderBtnProps) => {
  const { t } = useTranslate();
  const [updateFolder] = useUpdateFolderMutation();

  const handleRenameFolder = () => {
    modals.open({
      title: t('folder.rename.title'),
      children: (
        <FolderNameModal
          initialValue={folder.name}
          label={t('folder.name')}
          submitLabel={t('common.save')}
          onSubmit={async name => {
            try {
              await updateFolder({
                body: { name },
                id: folder.id,
              }).unwrap();
              notifications.show({
                color: 'green',
                message: t('folder.rename.success'),
              });
            } catch {
              notifications.show({
                color: 'red',
                message: t('folder.rename.error'),
              });
            }
          }}
        />
      ),
    });
  };

  return (
    <Tooltip label={t('folder.rename.title')} withArrow>
      <ActionIcon
        variant="subtle"
        color="blue"
        onClick={handleRenameFolder}
        aria-label={t('folder.rename.title')}
      >
        <IconPencil size={18} />
      </ActionIcon>
    </Tooltip>
  );
};

export default RenameFolderBtn;
